module.exports = __webpack_public_path__ + "helveticaltstd-roman-webfont.07fb3f207416362b8a6d.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/helveticaltstd-roman-webfont.eot
// module id = ../../../../../src/assets/fonts/helveticaltstd-roman-webfont.eot
// module chunks = styles